
// Get data 
export const fetchingData = async (url, requestRequirements) => {  
        try{
            const res = await fetch(url, requestRequirements)
            if(!res.ok) {
                console.error('Could not fetch', res.status)
                return false
            }

            return   await res.json()
            
        } catch(err) {
            console.error('Could not fetch', err.message)
            return false
        }
}  
